import SecondaryReadingPaneTabData from './SecondaryReadingPaneTabData';

export enum TabType {
    Primary,
    OverflowMenu,
    SecondaryReadingPane,
    Compose,
    FloatingChat,
}

interface TabViewStateBase {
    id: string;
    isActive: boolean;
    isShown: boolean;
    startTime?: number;
    parentTabId?: string;
    blink: boolean;
}

export interface PrimaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.Primary;
}

export interface SecondaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.SecondaryReadingPane;
    data: SecondaryReadingPaneTabData;
}

export interface OverflowTabViewState extends TabViewStateBase {
    type: TabType.OverflowMenu;
    data: TabViewState[];
}

export interface ComposeTabViewState extends TabViewStateBase {
    type: TabType.Compose;
    data: string /* composeId */;
}

export interface FloatingChatTabViewState extends TabViewStateBase {
    type: TabType.FloatingChat;
    data: string /* conversationId */;
    isChatActive: boolean;
}

type TabViewState =
    | PrimaryReadingPaneTabViewState
    | SecondaryReadingPaneTabViewState
    | OverflowTabViewState
    | ComposeTabViewState
    | FloatingChatTabViewState;

export default TabViewState;
